import { render, staticRenderFns } from "./LyricsModal.vue?vue&type=template&id=576f0f46&scoped=true"
import script from "./LyricsModal.vue?vue&type=script&lang=ts"
export * from "./LyricsModal.vue?vue&type=script&lang=ts"
import style0 from "./LyricsModal.vue?vue&type=style&index=0&id=576f0f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f0f46",
  null
  
)

export default component.exports